export enum AppStoreKeys {
  Session = 'session',
  ToggleFeatures = 'features'
}
